import React from 'react';
import {
	Modal, Button,

} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import validator from './../common/validator.js';
import * as SVGICONS from '../../images/img/images';
import * as signinActions from '../../actions/signinActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
var countries = require('country-data').countries
const autoBind = require('auto-bind');

//login container component
class Signup extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			patternOne: false,
			patternTwo: false,
			patternThree: false,
			patternFour: false,
			popoverShow: false,
			spinner: false,
			userType: { value: '1', isValid: true, message: '' },
			email: { value: '', isValid: true, message: '' },
			password: { value: '', isValid: true, message: '' },
			cpassword: { value: '', isValid: true, message: '' }

		};
		//binding current context to all functions
		this.onChange = this.onChange.bind(this);
		this.onSignupHandler = this.onSignupHandler.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.formIsValid = this.formIsValid.bind(this);
		this.resetValidationStates = this.resetValidationStates.bind(this);

	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.signup && nextProps.signup.success) {

			this.setState({ spinner: false })
			//	this.props.hideSignupModal()
		} else {
			this.setState({ spinner: false })
		}

	}

	componentWillMount() {
		var state = this.state;
		state['userType'].value = localStorage.getItem('userType') ? localStorage.getItem('userType') : '1'
		this.setState(state)

		navigator.geolocation.getCurrentPosition(
			function (position) {
				var lat = position.coords.latitude;
				var lng = position.coords.longitude;
				localStorage.setItem('lat', lat);
				localStorage.setItem('lng', lng);
				axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
					.then(function (response) {
						if (response) {
							for (var i = 0; i < response.data.results.length; i++) {
								if (response.data.results[i].types[0] == 'country') {
									var countryshort = response.data.results[i].address_components[0].short_name;
									var countrylong = response.data.results[i].address_components[0].long_name;

									localStorage.setItem('country_short', countryshort)
									localStorage.setItem('country_long', countrylong)
									localStorage.setItem('currency', countries[countryshort].currencies[0]);
									localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
									localStorage.removeItem('mileDistance', 0)
								}
							}
						}
						else {
						}
					})
			});

	}

	//Handler for sign-up
	onSignupHandler(event) {
		event.preventDefault();
		var state = this.state;

		if (state.email || !state.email) {
			if (state.email.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				}
				else {
					state.email.isValid = true;
					state.email.message = '';
					//return true
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		}
		if (state.password || !state.password) {
			this.setState({ popoverShow: true })
			if (state.password.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;

					}
				}
				else {
					//return
					state.password.isValid = true;
					state.password.message = '';
				}

				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		}
		if (state.cpassword || !state.cpassword) {
			if (state.cpassword.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					state.cpassword.isValid = true;
					state.cpassword.message = '';
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		}

		if (this.state.email.value != '' && this.state.password.value != '' && this.state.cpassword.value != '' && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.cpassword.message == '' || this.state.cpassword.message == undefined) && (this.state.patternOne == true) && (this.state.patternTwo == true) && (this.state.patternThree == true) && (this.state.patternFour == true)) {

			var signup = {
				userType: parseInt(this.state.userType.value),
				email: this.state.email.value,
				password: this.state.password.value,
				cpassword: this.state.cpassword.value
			}
			this.props.actions.signUpUser(signup);

			var statee = this.state;
			statee.spinner = true;
			statee.email.value = '';
			statee.cpassword.value = '';
			statee.password.value = '';
			statee.popoverShow = false;
			this.setState(statee);
		}
	}


	onChange(e) {
		var state = this.state;
		state[e.target.name].value = e.target.value;
		this.resetValidationStates();
		if (e.target.name == "email") {
			if (e.target.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					return true
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else
			if (e.target.name == "password") {
				this.setState({ popoverShow: true })
				if (e.target.value.length > 0) {
					if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
						if (validator.atLeastOneLetter(state.password.value)) {
							state.patternOne = true;
						} else {
							state.patternOne = false;
						}
						if (validator.atLeastOneCapitalLetter(state.password.value)) {
							state.patternTwo = true;
						} else {
							state.patternTwo = false;
						}
						if (validator.atLeastOneNumber(state.password.value)) {
							state.patternThree = true;
						} else {
							state.patternThree = false;
						}
						if (validator.atLeastEightCharacters(state.password.value)) {
							state.patternFour = true;
						} else {
							state.patternFour = false;

						}
					} else {
						return true
					}
					if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
						state.password.isValid = true;
						state.password.message = '';
						state.popoverShow = false;
					} else {
						state.password.isValid = false;
						state.password.message = 'Not a valid password';
						state.popoverShow = true;
					}
				} else {
					state.patternOne = false;
					state.patternTwo = false;
					state.patternThree = false;
					state.patternFour = false;
					state.password.isValid = false;
					state.password.message = 'Password is required';
					state.popoverShow = false;
				}
			} else if (e.target.name == "cpassword") {
				if (e.target.value.length > 0) {
					if (state.password.value != state.cpassword.value) {
						state.cpassword.isValid = false;
						state.cpassword.message = 'Passwords do not match';
						this.setState(state);
					} else {
						return true
					}
				} else {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Confirm password is required';
					this.setState(state);
				}

			}

		this.setState(state);

	}

	onSubmit(e) {
		e.preventDefault();
		this.resetValidationStates(); //reset states before the validation procedure is run.
		if (this.formIsValid()) { //run the validation, and if it's good move on.
			//form processing here....
		}
	}

	formIsValid(name) {
		var state = this.state;
		if (name == "email" && !validator.isEmail(state.email.value)) {
			state.email.isValid = false;
			state.email.message = 'Not a valid email address';

			this.setState(state);
			return false;
		} else {
			return true;
		}

		if (name == "password" && !validator.isPassword(state.password.value)) {
			state.password.isValid = false;
			state.password.message = 'Not a valid password';

			this.setState(state);
			return false;
		}
		return true;
	}

	resetValidationStates() {
		var state = this.state;

		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}
	// resetValidationField() {
	// 	var state = this.state;

	// 	Object.keys(state).map(key => {
	// 		if (state[key].hasOwnProperty('isValid')) {
	// 			state[key].isValid = true;
	// 			state[key].message = '';
	// 		}
	// 	});
	// 	this.setState(state);
	// }


	render() {
		var { email, password, cpassword } = this.state;

		var emailGroupClass = classNames('input-group', { 'has-error': !email.isValid });
		var passwordGroupClass = classNames('input-group', { 'has-error': !password.isValid });
		var confirmGroupClass = classNames('input-group', { 'has-error': !cpassword.isValid });
		return (
			<Modal show={this.props.show} size="modal-sm" onHide={(e) => this.props.hideSignupModal(e)}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideSignupModal} /> */}
					<Modal.Title><img src={require('../../images/images/logo.svg')} alt="" /></Modal.Title>
					{/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
				</Modal.Header>
				<Modal.Body>
					<form className="signup-form" id="loginForm" onSubmit={this.onSignupHandler}>
						<div className="signIn changePass">Create an Account</div>
						<p className="signUp">Already have an account? <a href="#"onClick={this.props.closeSignupOpenSignin} style={{cursor:'pointer'}}>Sign In</a></p>
						<div className="userSpecialist">
							<div className="cc-selector">
								<input id="patient_img_radio" type="radio" name="userType" value="1" onChange={this.onChange} checked={this.state.userType.value === '1'} />
								<label className="drinkcard-cc userImg patient_img_radio" htmlFor="patient_img_radio"></label>
								<input id="specialist_img_radio" type="radio" name="userType" value="2" onChange={this.onChange} checked={this.state.userType.value === '2'} />
								<label className="drinkcard-cc specialist_img_radio" htmlFor="specialist_img_radio"></label>
							</div>
						</div >
						{/* <ToastContainer /> */}
						<div className="loginInput">
							<div className="input-group bordernoneinput">
								<div className="input-group-prepend">
									<span className="input-group-text" id="inputGroupPrepend">
										<SVGICONS.EmailSvg />
									</span>
								</div>
								<input type="text" name="email" className="form-control"
									placeholder="Email address" value={email.value} onChange={this.onChange} autoFocus onClick={this.handlePopover} />
								<span className="help-block">{email.message}</span>
							</div>

							<div className="input-group">
								<div className="input-group-prepend">
									<span className="input-group-text" id="inputGroupPrepend">
										<SVGICONS.PasswordSvg />
									</span>
								</div>
								<input type="password" name="password" className="form-control"
									placeholder="Password" value={password.value} onChange={this.onChange} />
								<span className="help-block">{password.message}</span>
								{this.state.popoverShow == true ? <div className="toolTip">
									<div className="tool_box">
										<p>Password must Meet the following requirements: </p>
										<ul>
											<li>{this.state.patternOne == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>} At least one letter</li>
											<li>{this.state.patternTwo == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one capital letter</li>
											<li>{this.state.patternThree == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one number</li>
											<li>{this.state.patternFour == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}Be at least 8 characters	</li>
										</ul>
									</div>
								</div> : ''}
							</div>
							<div className="input-group">
								<div className="input-group-prepend">
									<span className="input-group-text" id="inputGroupPrepend">
										<SVGICONS.PasswordSvg />
									</span>
								</div>
								{/* id="cpassword" ref="cpassword"   defaultValue=""*/}
								<input type="password" className="form-control" value={cpassword.value} name="cpassword" placeholder="Confirm Password" onChange={this.onChange} />
								<span className="help-block">{cpassword.message}</span>
							</div>
							<p className="loginTLink">By signing up you agree to {window.location.pathname != '/' ? <Link to="/marketing/terms" className="forgetPass " onClick={this.props.hideSignupModal}> Medfix Terms &amp; Conditions</Link> : <Link to="/marketing/terms" className="forgetPass "> Medfix Terms &amp; Conditions</Link>}</p>
							<div className="btngrouplogIn">
								<button className="btn btn-primary btn-signup" type="submit" >Sign Up{this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
							</div>
						</div>
					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		signup: state.signin.userData
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(signinActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Signup);
// export default (Signup);
